import React from "react";

const Context = React.createContext({});
const Provider = Context.Provider;
const Consumer = Context.Consumer;

export { Context, Provider, Consumer };
